import React,{useState,useEffect} from 'react';
import PostComment from './PostComment';

const CommentInput=({surahNum, ayahNum, commentCat, closeWithRefresh, closeFunc, pageType})=>{
    return(
        <div className={`bg-light-beige dark:bg-deep-blue rounded-lg p-[15px]`}>
            <PostComment surah={surahNum} ayah={ayahNum} refreshFunc={closeWithRefresh} cancelFunc={closeFunc} cmntCat={commentCat} pageType={pageType}/>
        </div>
    );
}

export default CommentInput;